<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">商务合同回款</el-menu-item>
		  <el-menu-item index="list2">录入回款</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
			<Business v-if="activeIndex == 'list'" @isedit="isedit"></Business>
			<enterMoney v-if="activeIndex == 'list2'"></enterMoney>
      </div>
    </div>
  </div>
</template>

<script>
import Business from './business.vue';//此页面与回款认领下的回款列表共用
import enterMoney from './enterMoney.vue';//此页面与回款认领下的回款列表共用
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
    };
  },
  components: {
	Business,
	enterMoney,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
	// 子传父回款认领
	isedit(val){
		console.log('我是传回来的id',val)
		this.activeIndex = 'claim'
	},
  },
};
</script>